import 'css-chunksrc/client/pages/documentsPage/documentsPage/edit/styles.scss';export default {
  "preview": "_preview_uo1uy_1",
  "footer": "_footer_uo1uy_13",
  "loader": "_loader_uo1uy_22",
  "closeButton": "_closeButton_uo1uy_37"
};